import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store.js'
import $axios from './axiosInstance.js'
import PortalVue from 'portal-vue'
import NProgress from 'nprogress'
import _ from 'lodash'
import VeeValidate from 'vee-validate';
import Datetime from 'vue-datetime'

import 'nprogress/nprogress.css'
import './main.css'
import 'vue-datetime/dist/vue-datetime.css'
import Default from '@/layouts/Default.vue'
import FetchJson from '@/components/FetchJson.vue'
import ActionButton from '@/components/common/ActionButton.vue'
import ConfirmDelete from '@/components/common/ConfirmDelete.vue'
import OrdersModal from '@/components/common/OrdersModal.vue'
import ChevronComponent from '@/components/common/ChevronComponent.vue'

import { ZapIcon, CheckIcon, SaveIcon, ArrowLeftIcon, PlusIcon, MinusIcon, CopyIcon, ClipboardIcon, EditIcon, ListIcon, EyeIcon, ActivityIcon, CheckCircleIcon, ClockIcon, TrashIcon, DownloadIcon, AlertCircleIcon, BoxIcon, FileTextIcon, RefreshCwIcon } from 'vue-feather-icons'

Vue.component('default-layout', Default)
Vue.component('fetch-json', FetchJson)
Vue.component('action-button', ActionButton)
Vue.component('confirm-delete', ConfirmDelete)
Vue.component('orders-modal', OrdersModal)
Vue.component('chevron-component', ChevronComponent)

Vue.component('zap-icon', ZapIcon)
Vue.component('arrow-left-icon', ArrowLeftIcon)
Vue.component('check-icon', CheckIcon)
Vue.component('plus-icon', PlusIcon)
Vue.component('minus-icon', MinusIcon)
Vue.component('copy-icon', CopyIcon)
Vue.component('clipboard-icon', ClipboardIcon)
Vue.component('edit-icon', EditIcon)
Vue.component('list-icon', ListIcon)
Vue.component('eye-icon', EyeIcon)
Vue.component('datetime', Datetime);
Vue.component('activity-icon', ActivityIcon);
Vue.component('check-circle-icon', CheckCircleIcon);
Vue.component('clock-icon', ClockIcon);
Vue.component('trash-icon', TrashIcon);
Vue.component('download-icon', DownloadIcon);
Vue.component('alert-circle-icon', AlertCircleIcon);
Vue.component('box-icon', BoxIcon);
Vue.component('save-icon', SaveIcon);
Vue.component('file-text-icon', FileTextIcon);
Vue.component('refresh-cw-icon', RefreshCwIcon);

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: 'ZAR',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});


Object.defineProperty(Vue.prototype, '$_', { value: _ })

//configuration for veeValidate
const config = {
	aria: true,
	classNames: {},
	classes: false,
	delay: 0,
	dictionary: null,
	errorBagName: 'validationerrors', // change if property conflicts
	events: 'input|blur',
	fieldsBagName: 'fields',
	i18n: null, // the vue-i18n plugin instance
	i18nRootKey: 'validations', // the nested key under which the validation messages will be located
	inject: true,
	locale: 'en',
	validity: false,
	useConstraintAttrs: true
  };
Vue.use(PortalVue)
Vue.use(VeeValidate, config)
Vue.config.productionTip = false
Vue.use(Datetime)

$axios.interceptors.request.use((config) => {
	NProgress.start()
	store.commit('setLoading', true)
	const token = store.getters['auth/token']
	if (token) {
		config.headers.Authorization = `Bearer ${token}`
	}
	return config
})

$axios.interceptors.response.use(response => {
	store.commit('setLoading', false)
	NProgress.done()
	if(response.data.success == false ||  response.data.success == 'false'){
		let err = {
			title: 'Error',
			message: response.data.message,
			type: 'error'
		}
		store.commit('setStatus', err)
		return Promise.reject(response)
	}
	return response
}, function (error) {
	store.commit('setLoading', false)
	NProgress.done()
	let err = {
		title: 'Server responded with a ' + error.response.status,
		message: error.response.data.message,
		type: 'error'
	}
	store.commit('setStatus', err)
	if (error.response.status === 401 && error.config && !error.config.__isRetryRequest) {
		store.dispatch('auth/logout')
	}
	return Promise.reject(error)
})

Vue.prototype.$http = $axios

new Vue({
	router,
	store,
	created () {
		// window.addEventListener('beforeunload', (e) => {
		// e.preventDefault();
		// // Chrome requires returnValue to be set
		// e.returnValue = '';
		// }, false)
	},
	render: h => h(App)
}).$mount('#app')
